import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Spinner, Text, Flex, Image, Heading, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useColorMode } from "@chakra-ui/react";
import RegisterModal from "./RegisterModal";
import FullScreenMessage from "./FullScreenMessage";
import { cqAPI } from "../../../lib/Auth";
import {searchParamsToRemove} from "../../MenuComponent/MenuComponent";

const Availabilities = () => {
  const { serviceId, date } = useParams();
  const [hasError, setHasError] = useState(false);
  const day = date.replace(/-/g, "/");
  const navigate = useNavigate();
  const location = useLocation();
  const [availability, setAvailability] = useState([]);
  const [, setService] = useState({});
  const [, setOfficeData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [serverMessage, setServerMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { colorMode } = useColorMode();
  const toast = useToast();
  const params = new URLSearchParams(window.location.search);
  const provider_id = params.get('provider_id');
  const app_id = params.get('app_id');

  useEffect(() => {
    setIsLoading(true);
    const locationParams = new URLSearchParams(location.search);
    const timepref = locationParams.get('timepref');
    const searchParams = new URLSearchParams({
      service_id: serviceId,
      day,
      ...(timepref ? {timepref} : {}),
      ...(provider_id? {pms_provider_id : provider_id} : {}),
      ...(app_id? {pms_app_id : app_id} : {})
    });
    cqAPI
      .get(`/times?${searchParams.toString()}`) 
      .then((data) => {
        if (data.type === "ok") {
          setAvailability(data.data.availabilities);
          setService(data.data.service);
          setOfficeData(data.data.business);
        } else {
          if (data.code) {
            setHasError(true);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setHasError(true);
        setIsLoading(false);
      });
  }, [serviceId, day]);

  if (hasError) {
    return <FullScreenMessage message="This is not a valid link" />;
  }

  if (isLoading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  const handleDayClick = (timeInfo) => {
    setSelectedTimeSlot(timeInfo);
    setIsModalOpen(true);
  };

  const changeDay = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('timepref');

    navigate({
      pathname: `/appointments/new/service/${serviceId}`,
      search: `?${searchParams.toString()}`
    });
  };

  const handleRegister = (e) => {
    setIsSubmitting(true);
    const params = new URLSearchParams(window.location.search);
    const note = params.get('note')
    const request = app_id? cqAPI.put(`/appointment/${app_id}?author_entity=pp`,{
      ...selectedTimeSlot,
      date : selectedTimeSlot.date,
    }) : cqAPI.post('/pp/book?author_entity=pp',{
      appointment: { 
        ...selectedTimeSlot,
        ...note? {note} : {}
      }
    });
    
    request.then(data => {
      setIsSubmitting(false);
      if (data.type === 'ok') {
        setIsModalOpen(false);
        if (data.msg) {
          setServerMessage(data.msg);
          setIsConfirmModalOpen(true);
        }

        const newSearchParams = new URLSearchParams(location.search);
        searchParamsToRemove.map(key => newSearchParams.delete(key));

        navigate({
          pathname: `/appointments`,
          search: `?${newSearchParams.toString()}`,
        });
      } else if (data.type === 'error') {
        if (data.msg) {
          toast({
            title: "Error confirming appointment.",
            description: data.msg,
            status: "error",
            duration: 9000,
            isClosable: true,
          });
        }
      }
    }).catch(error => {
      console.log(error);
      setIsModalOpen(false);
    });
  };

  return (
    <Box padding="40px" bg={colorMode === "light" ? "white" : "gray.800"} borderRadius="md" boxShadow="md" className="availability-container availability-day" id="availability-container">
      <Text className="instruction" fontSize="md">
        Select the time. You will review and confirm next.
      </Text>
      <Flex justifyContent="space-between" alignItems="center" borderBottom="1px solid gray" pb={2} mb={4}>
        <Text></Text>
        <Button className="change-service" onClick={changeDay} cursor="pointer">
          Change Date
        </Button>
      </Flex>
      {availability.map((dayInfo, index) => (
        <Box
          key={index}
          className="day-block actionableItem"
          onClick={() => handleDayClick(dayInfo)}
          border="1px"
          borderColor="gray.200"
          borderRadius="md"
          p={4}
          mb={4}
          cursor="pointer"
          _hover={{ bg: "gray.100" }}
        >
          <Flex alignItems="center">
            <Image src={dayInfo.img} alt={dayInfo.name} boxSize="50px" borderRadius="full" mr={4} />
            <Box>
              <Heading as="h4" size="md">
                {dayInfo.title ? dayInfo.title + " " : ""}
                {dayInfo.name}
              </Heading>
              <Text>{dayInfo.time}</Text>
            </Box>
          </Flex>
        </Box>
      ))}
      {isModalOpen && (
        <RegisterModal
          onRegister={handleRegister}
          onClose={() => setIsModalOpen(false)}
          selectedTimeSlot={selectedTimeSlot}
          isSubmitting={isSubmitting}
        />
      )}
      {isConfirmModalOpen && (
        <Modal isOpen={isConfirmModalOpen} onClose={() => setIsConfirmModalOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation</ModalHeader>
            <ModalBody>
              <Text>{serverMessage}</Text>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => setIsConfirmModalOpen(false)}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default Availabilities;
